import {HttpErrorResponse} from '@angular/common/http';
import { Injectable } from '@angular/core';
import {throwError} from "rxjs";
import {CustomToastrComponent} from "../../main/extensions/toastr/custom-toastr/custom-toastr.component";
import { cloneDeep } from 'lodash';
import {GlobalConfig, ToastrService} from "ngx-toastr";

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  private options: GlobalConfig;
  constructor(private toastr: ToastrService) {
    this.options = this.toastr.toastrConfig;

  }

  error(error: HttpErrorResponse) {

    const customToastrRef = cloneDeep(this.options);
    customToastrRef.toastComponent = CustomToastrComponent;
    customToastrRef.closeButton = true;
    customToastrRef.tapToDismiss = false;
    customToastrRef.progressBar = true;
    customToastrRef.toastClass ='toast ngx-toastr';

      if (error.status === 0) {
        // A client-side or network error occurred. Handle it accordingly.
        this.toastr.error('Something went wrong Please try again!', 'Error!', customToastrRef);
        console.error('An error occurred:', error.error);
      } else {
        // The backend returned an unsuccessful response code.
        // The response body may contain clues as to what went wrong.
        this.toastr.error('Something went wrong Please try again!', 'Error!', customToastrRef);
        console.error(`Backend returned code ${error.status}, body was: `, error.error);
      }
      // Return an observable with a user-facing error message.
      return throwError(() => new Error('Something bad happened; please try again later.'));
  }

  success(response: any) {
    const customToastrRef = cloneDeep(this.options);
    customToastrRef.toastComponent = CustomToastrComponent;
    customToastrRef.closeButton = true;
    customToastrRef.tapToDismiss = false;
    customToastrRef.progressBar = true;
    customToastrRef.toastClass ='toast ngx-toastr';

      if (response.status === "success") {
        this.toastr.success(response.message, response.status, customToastrRef);
      } else {
        // The backend returned a response code.
        // The response body may contain clues as to what went wrong.
        this.toastr.error(response.message, response.status, customToastrRef);
        console.error(`Backend returned code ${response.responseCode}, body was: `, response.message);
      }
  }

  preRequestSearch(){
    const customToastrRef = cloneDeep(this.options);
    customToastrRef.toastComponent = CustomToastrComponent;
    customToastrRef.closeButton = true;
    customToastrRef.tapToDismiss = false;
    customToastrRef.progressBar = true;
    customToastrRef.toastClass ='toast ngx-toastr';

    this.toastr.info('Kindly request your attention to filtering at least one field!', 'Info!', customToastrRef);
  }

  customizedInfo(error: string) {
    const customToastrRef = cloneDeep(this.options);
    customToastrRef.toastComponent = CustomToastrComponent;
    customToastrRef.closeButton = true;
    customToastrRef.tapToDismiss = false;
    customToastrRef.progressBar = true;
    customToastrRef.toastClass ='toast ngx-toastr';
    this.toastr.info(error, 'Info!', customToastrRef);
  }

    customizedWarning(error: string) {
        const customToastrRef = cloneDeep(this.options);
        customToastrRef.toastComponent = CustomToastrComponent;
        customToastrRef.closeButton = true;
        customToastrRef.tapToDismiss = false;
        customToastrRef.progressBar = true;
        customToastrRef.toastClass ='toast ngx-toastr';
        this.toastr.warning(error, 'Warning!', customToastrRef);
    }

}
